<template>
  <div class="big">
    <div class="page_title">用户标签管理</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>标签类别</span>
            <el-select
              v-model="label_type"
              placeholder="请选择"
              style="width:220px;margin-left:10px"
              @change="search"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <el-option
                v-for="item in labelTypeList"
                :key="item.label_type"
                :label="item.label_type_name"
                :value="item.label_type"
              >
              </el-option>
            </el-select>
          </div>
          <el-button
            type="primary"
            @click="openAddDia"
            style="width: 120px"
            :disabled="
                  module_id_array[0] ? !module_id_array.includes('1368') : false
                "
          >添加标签</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="标签名"
              prop="label_name"
            ></el-table-column>
            <el-table-column
              label="标签类别"
              prop="label_type_name"
            >
            </el-table-column>
            <el-table-column
              label="用户数"
              prop="user_count"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row)"
                  :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1373')
                          : false
                      "
                >详情</el-button>
                <el-button
                  type="text"
                  @click="editDia(scope.row)"
                  :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1369')
                          : false
                      "
                >编辑</el-button>
                <el-button
                  type="text"
                  v-if="!scope.row.user_count"
                  @click="delLabel(scope.row.label_id)"
                  :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1370')
                          : false
                      "
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addDia"
      width="400px"
      :title="title"
    >
      <div class="mydia">
        <div>
          <span class="title">
            <span style="color:red">*</span>
            <span>标签名</span>
          </span>
          <el-input
            v-model="addData.label_name"
            style="width:200px"
            maxlength="10"
          ></el-input>
        </div>
        <div style="margin:20px 0">
          <span class="title">
            <span style="color:red">*</span>
            <span>标签类别</span>
          </span>
          <el-select
            v-model="addData.label_type"
            placeholder="请选择"
            style="width:200px"
            :disabled="title=='编辑标签'"
          >
            <el-option
              v-for="item in labelTypeList"
              :key="item.label_type"
              :label="item.label_type_name"
              :value="item.label_type"
            >
            </el-option>
          </el-select>
        </div>
        <div style="text-align:center;margin:30px 0 10px">
          <el-button
            type="primary"
            size="medium"
            style="width: 92px"
            @click="sumbit"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      label_type: '',
      labelTypeList: [],
      addDia: false,
      title: '添加标签',
      addData: {
        label_name: '',
        label_type: ''
      },
      doctorId: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取标签类型
    getLabelType() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        type: 1
      };
      this.axios.post('platform/Admin/getLabelType', data).then((res) => {
        if (res.code == 0) {
          this.labelTypeList = res.data.list;
        }
      });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        label_type: this.label_type
      };
      this.axios.post('platform/patient/getUserLabelList', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    openAddDia() {
      this.title = '添加标签';
      this.addData = {
        label_name: '',
        label_type: ''
      };
      this.addDia = true;
    },
    editDia(row) {
      this.title = '编辑标签';
      this.addData = {
        label_name: row.label_name,
        label_type: row.label_type,
        label_id: row.label_id
      };
      this.addDia = true;
    },
    //提交
    sumbit() {
      if (!this.addData.label_name || !this.addData.label_type) {
        this.$message.error('请完善标签信息!');
        return false;
      }
      let data = this.addData;
      let url = 'platform/patient/addUserLabel';
      if (this.title == '编辑标签') {
        url = 'platform/patient/updateUserLabel';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.addDia = false;
          this.getList();
        }
      });
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.addData.label_img = res.data.pic;
        this.addData.label_img_str = res.data.path;
      }
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 4;
      this.uploadHeaders.timestamp = Date.now();
      return isSupportType;
    },
    //详情
    toDetail(row) {
      this.$router.push({
        path: 'labeldetail',
        query: {
          label_id: row.label_id,
          label_name: row.label_name,
          label_type_name: row.label_type_name
        }
      });
    },
    //删除
    delLabel(label_id) {
      this.$confirm('确定删除该标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/patient/deleteUserLabel', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getLabelType();
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.imgbox {
  display: flex;
  box-sizing: border-box;
  text-align: center;
}
.uploadimg {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;
  .avatar {
    width: 120px;
    height: 120px;
  }
  .uploader-icon {
    padding-top: 10px;
    line-height: 20px;
    color: #669961;
  }
}
.mydia {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
  .title {
    display: inline-block;
    width: 90px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>